<template>
  <v-form ref="search-form" :class="['bc-search']" @submit.prevent="search">
    <v-card>
      <v-card-text>
        <v-layout row wrap>
          <v-flex lg10 :class="['pr-2']">
            <v-text-field :disabled="loading" prepend-icon="mdi-magnify" :rules="rulesSearch" :color="$config.colors.primary" v-model="postData.q" :placeholder="$lang.searchBandcamp" />
          </v-flex>
          <v-flex lg2 :class="['pt-3']">
            <v-btn :loading="loading" dark block small :title="$lang.searchBandcamp" aria-label="search-bandcamp" type="submit" :color="$config.colors.primary">{{ $lang.searchBandcamp }}</v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="error">
          <v-flex lg12 md12 sm12 xs12>
            <v-alert type="info" :color="$config.colors.primary" :value="error">{{ $lang.noResults(postData.q) }}</v-alert>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="results">
          <v-flex lg12 md12 sm12 xs12 :class="['text-xs-center']">
            <p v-html="$lang.searchSummary(postData.q, results.count)" :class="['mb-0']" />
          </v-flex>
          <v-flex lg12 md12 sm12 xs12 :class="['text-xs-center', 'py-4']">
            <v-pagination :disabled="loading" @input="goToPage" :color="$config.colors.primary" v-model="postData.page" :length="results.pages" />
          </v-flex>
          <v-flex lg12 md12 sm12 xs12>
            <v-card>
              <v-card-text>
                <v-list two-line dense>
                  <template v-for="(value, key) in results.results">
                    <template v-for="(result, index) in value">
                      <v-list-tile :key="key + index" :class="['clickable']" @click="showResultItemData(result)">
                        <v-list-tile-avatar>
                          <v-img :src="result.art" />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ result.name }}</v-list-tile-title>
                          <v-list-tile-sub-title>
                            <span :class="['caption']" v-html="result.type.toUpperCase()" />
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-icon>mdi-chevron-double-right</v-icon>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider :key="`${key + index}-divider`" />
                    </template>
                  </template>
                </v-list>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex lg12 md12 sm12 xs12 :class="['text-xs-center', 'py-4']">
            <v-pagination @input="goToPage" :color="$config.colors.primary" v-model="postData.page" :length="results.pages" />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-form>
</template>
<script>
import rulesSearch from '../helpers/rules-search'

export default {
  name: 'BcSearch',
  data () {
    return {
      rulesSearch,
      error: false,
      loading: false,
      results: null,
      postData: {
        q: '',
        page: 1
      }
    }
  },
  watch: {
    'postData.q' () {
      if (!this.postData.q) {
        this.postData.page = 1
      }
      this.error = false
    }
  },
  methods: {
    showResultItemData (data) {
      console.log(data)
    },
    search () {
      if (this.$refs['search-form'].validate() && !this.loading) {
        this.loading = true
        this.error = false
        this.$http({
          url: `${this.$config.apiRoot}/search`,
          method: 'POST',
          data: this.postData
        }).then(response => {
          this.results = response.data.data
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.error = true
          this.results = null
          console.error(error)
        })
      }
    },
    goToPage (page) {
      this.postData.page = page
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bc-search.vue